<script setup lang="ts">
import { usePage } from '@inertiajs/vue3';
import { onMounted, watch } from 'vue';
import { Toaster } from '@/components/ui/sonner';
import { useToast } from '@/composables/useToast';
import { useTour } from '@/composables/useTour';
import { useUserChannel } from '@/composables/useUserChannel';
import SidebarLayout from '@/layouts/app/AppSidebarLayout.vue';
import type { BreadcrumbItem } from '@/types';
import 'vue-sonner/style.css';

const { breadcrumbs = [] } = defineProps<{
    breadcrumbs?: BreadcrumbItem[];
}>();

const { notifications } = useUserChannel();
const toast = useToast();
const page = usePage();
const { startTour } = useTour();

onMounted(() => {
    if ((page.props as any).showTutorial) {
        setTimeout(() => startTour(), 800);
    }
});

watch(
    () => page.props.flash,
    (flash: any) => {
        if (typeof window === 'undefined') {
            return;
        }

        if (!flash) {
            return;
        }

        if (flash.success) {
            toast.success(flash.success);
        }

        if (flash.error) {
            toast.error(flash.error);
        }

        if (flash.warning) {
            toast.warning(flash.warning);
        }

        if (flash.info) {
            toast.info(flash.info);
        }
    },
    { deep: true, immediate: true },
);
</script>

<template>
    <SidebarLayout :breadcrumbs="breadcrumbs" :notifications="notifications">
        <slot />
    </SidebarLayout>
    <Toaster />
</template>
